import React, { useEffect, useState } from "react";
import { 
    Flex, 
    Stack, 
    Heading, 
    Text, 
    Box, 
    Button, 
    HStack, 
    Select, 
    FormControl, 
    FormLabel, 
    Input, 
    NumberInput, 
    NumberInputField, 
    NumberInputStepper, 
    NumberIncrementStepper, 
    NumberDecrementStepper, 
    useToast
} from "@chakra-ui/react";
import { Form, Formik } from 'formik';
import * as Yup from 'yup';
import axios from 'axios';
import CustomFormInput from "../components/FormInputFields";
import CommonVars from "../components/CommonVars"

function AddProductScreen() {
    if (localStorage.getItem('token') === null || JSON.parse(localStorage.getItem('userDetails')).role !== "admin") {
        window.location.replace("/unauthorized");
    }
    const theToken = localStorage.getItem('token');
    const [categories, setCategories] = useState([]);
    // access backend to retrieve all categories
    const getCategories = async () => {
        axios.get(`${CommonVars.API_URL}/category`)
        .then((res) => {
            // console.log(res.data);
            setCategories(res.data);
        })
        .catch((error) => {
            console.log(error);
        })
    }

    useEffect(() => {
        getCategories();
    })

    // set add product toast message
    const addPdtToast = useToast();
    const id = 'addPdt-toast';

    const category = [];

    for (let i = 0; i < categories.length; i++) {
        category.push(
            <option key={categories[i].categoryid} value={categories[i].categoryid}>{categories[i].categoryname}</option>
        )
    }

    return (
        <Formik
            initialValues={{
                productName: '',
                description: '',
            }}
            validationSchema={Yup.object({
                productName: Yup.string()
                .min(4, 'Product name must be at least 4 characters long')
                .required('Product name is required'),
                description: Yup.string()
                .required('Product description is required'),
            })}
            onSubmit = {(values, { setSubmitting, resetForm }) => {
                // retrieve all relevant details for posting product
                const pdtName = String(values.productName);
                const pdtDesc = String(values.description);
                const inPrice = document.getElementById('price');
                const price = parseInt(inPrice.value);
                const catSelected = document.getElementById('dropDownCats')
                const catID = parseInt(catSelected.value, 10);
                // form data for image uploading
                const formData = new FormData();
                const file = document.getElementById('pdtImg').files[0];
                formData.append('image', file);

                // access backend apis to post a new product 
                axios.post(`${CommonVars.API_URL}/upload-pdtImg`, formData, { headers: { Authorization: `Bearer ${theToken}` } })
                .then((res) => {
                    console.log(res);
                    const uploadedPdtImg = res.data;
                    // prepare the request body to post new product
                    const addPdtRequestBody = {
                        name: pdtName,
                        price,
                        desc: pdtDesc,
                        p_img_url: uploadedPdtImg,
                        categoryid: catID
                    }
                    // access endpoint to post the new product
                    return axios.post(
                        `${CommonVars.API_URL}/products`,
                        addPdtRequestBody,
                        { headers: { Authorization: `Bearer ${theToken}` } }
                    )
                    .then(() => {
                        setSubmitting(false);
                        if(!addPdtToast.isActive(id)) {
                            addPdtToast({
                                id,
                                title: 'New Product Added!',
                                description: "New product is added successfully!",
                                status: 'success',
                                position: 'top',
                                duration: 2000,
                                isClosable: true,
                            });
                        }
                        resetForm();
                    })
                    .catch((error) => {
                        if(!addPdtToast.isActive(id)) {
                            addPdtToast({
                                id,
                                title: 'Adding Failed.',
                                description: "Something went wrong with adding...",
                                status: 'error',
                                position: 'top',
                                duration: 2000,
                                isClosable: true,
                            });
                        }
                        console.log(error);
                    })
                })
                .catch((error) => {
                    console.log(error);
                })
            }}
        >
            {props => (
                <Flex 
                    minH={'100vh'}
                    align={'center'}
                    justify={'center'}
                    bg={'#F4F4F4'}
                >
                <Stack spacing={8} mx={'auto'} maxW={'lg'} py={12} px={6}>
                    <Stack align={'center'}>
                        <Heading fontSize={'4xl'}>Add a New Product</Heading>
                        <Text fontSize={'lg'} color={'gray.600'}>
                            Expand the collections of the website with a new product!
                        </Text>
                    </Stack>
                    <Box
                        rounded={'lg'}
                        bg={'white'}
                        boxShadow={'lg'}
                        p={8}
                    >
                        <Form>
                            <Stack spacing={4}>
                                {/* Product Name Input */}
                                <CustomFormInput
                                    label="Product Name" 
                                    name="productName" 
                                    type="text"
                                    placeholder="Enter Product Name"
                                />
                                {/* Product Description Input */}
                                <CustomFormInput
                                    label="Product Description" 
                                    name="description" 
                                    type="text"
                                    placeholder="Enter Product Description"
                                />
                                {/* Product Price */}
                                <FormControl>
                                    <FormLabel>Product Price</FormLabel>
                                    <NumberInput size='sm' maxW={20} defaultValue={100} min={10} required>
                                        <NumberInputField id="price" />
                                        <NumberInputStepper>
                                        <NumberIncrementStepper />
                                        <NumberDecrementStepper />
                                        </NumberInputStepper>
                                    </NumberInput>
                                </FormControl>
                                {/* Product Image Input */}
                                <FormControl>
                                    <FormLabel>Product Image</FormLabel>
                                    <Input id="pdtImg" placeholder='medium size' size='md' type={'file'} variant={'flushed'} required/>
                                </FormControl>
                                {/* Category Options */}
                                <FormControl>
                                    <FormLabel>Select Category</FormLabel>
                                        <Select id="dropDownCats">
                                            {category}
                                        </Select>
                                </FormControl>
                                <HStack spacing='20px' pt={2} pb={1}>
                                    <Button type='submit' bg={'black'} color={'white'} _hover={{bg: '#37404A',}}>{props.isSubmitting ? 'Loading...' : 'Add Product'}</Button>
                                    <Button type='reset'>Reset</Button>
                                </HStack>
                            </Stack>
                        </Form>
                    </Box>
                </Stack>
            </Flex>
            )}
        </Formik>
    )
}

export default AddProductScreen;
